<template>
  <SectionBox
    class="expert-score-block"
    :class="bem('expert-score-block', { slider: experts.length > 1, sidebar })"
  >
    <BasicSection appearance="same-paddings">
      <h2 class="expert-score-block__title">Оцените прошедшие встречи</h2>
      <BasicSlider
        :slides="experts"
        pagination-under
        prev-title="Предыдущая встреча"
        next-title="Следующая встреча"
        v-slot="{ slide: expert }"
      >
        <div class="expert-score-block__slide">
          <div class="expert-score-block__info">
            <ExpertInfo :expert="expert" no-wrap />
          </div>
          <div class="expert-score-block__score">
            <ExpertScoreForm
              :alias="expert.login"
              column
              @action="trackAction"
            />
          </div>
        </div>
      </BasicSlider>
    </BasicSection>
  </SectionBox>
</template>

<script>

  import { bem } from 'src/utils/bem.js';

  import BasicSlider from 'src/components/BasicSlider/BasicSlider.vue';
  import ExpertInfo from 'src/components/experts/ExpertInfo/ExpertInfo.vue';
  import ExpertScoreForm from 'src/components/experts/ExpertScoreForm/ExpertScoreForm.vue';
  import SectionBox from 'src/components/SectionBox/SectionBox.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';

  export default {
    name: 'ExpertScoreBlock',
    components: { BasicSection, SectionBox, ExpertInfo, ExpertScoreForm, BasicSlider },
    props: {
      experts: {
        type: Array,
        required: true,
      },
      sidebar: Boolean,
    },
    methods: {
      trackAction(action) {
        window.helpers.trackEvent('experts', 'review_experts', action);
      },
      bem,
    },
  };
</script>
